module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_12_2.ec8f9a5b.jpeg";